var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"device-development"},[_vm._v("设备详情页正在开发中")])
}
var staticRenderFns = []

export { render, staticRenderFns }